<script>
    import { translateText } from 'lang'
    import { format } from "api/formatter";

    import { executeClientAsync} from 'api/rage'

    let selectTaxi = {}

    const getCounter = () => {
        executeClientAsync("phone.taxi.getCounter").then((result) => {
            if (result && typeof result === "string") {
                selectTaxi = JSON.parse(result);
            }
        });
    }

    getCounter();
    import { addListernEvent } from 'api/functions';
    addListernEvent ("hud.taxi.updateCounter", getCounter);


</script>
{#if selectTaxi}
    <div class="magictaxi">
        <div class="taxiicon">
            <svg width="15" height="6" viewBox="0 0 15 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="3" height="3" transform="matrix(-1 0 0 1 15 0)" fill="#2B2B2B"></rect>
                <rect width="3" height="3" transform="matrix(-1 0 0 1 12 3)" fill="#2B2B2B"></rect>
                <rect width="3" height="3" transform="matrix(-1 0 0 1 9 0)" fill="#2B2B2B"></rect>
                <rect width="3" height="3" transform="matrix(-1 0 0 1 6 3)" fill="#2B2B2B"></rect>
                <rect width="3" height="3" transform="matrix(-1 0 0 1 3 0)" fill="#2B2B2B"></rect>
            </svg>                    
        </div>
        <p>{format("money", selectTaxi.price)}$</p>
        <span>Стоимость поездки</span>
    </div>
{/if}